import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomFunctionsPage } from "src/components/views/ai/customFunctions/CustomFunctionsPage.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/customizations/custom-functions")({
	staticData: { title: i18n.t("custom_functions"), legacyViewKey: "customFunctionsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <CustomFunctionsPage isActive={isActive} />;
}
